import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/academic.css';

import SidebarWidgets from './SidebarWidgets'; // Import new widgets

const AcademicLayout = ({ children }) => {
    const { currentUser, login, logout, loading, isRealAdmin } = useAuth(); // Use Global Auth Context

    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="academic-container">
            {/* Mobile Header (Sticky) */}
            <div className="mobile-header">
                <button className="hamburger-btn" onClick={toggleMobileMenu}>
                    ☰ MENU
                </button>
                <div className="mobile-brand">Hardik Gupta</div>
            </div>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && <div className="mobile-overlay" onClick={closeMobileMenu}></div>}

            {/* Sidebar Navigation */}
            <aside className={`academic-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="toc-header">
                    Table of Contents
                    <button className="close-sidebar-btn" onClick={closeMobileMenu}>×</button>
                </div>
                <nav>
                    <NavLink to="/" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [00] Index / Home
                    </NavLink>
                    <NavLink to="/academia" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [01] Academia
                    </NavLink>
                    <NavLink to="/finance" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [02] Quantitative Finance
                    </NavLink>
                    <NavLink to="/ml_ai" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [03] Machine Learning / Data
                    </NavLink>
                    <NavLink to="/software_infra" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [04] Engineering
                    </NavLink>
                    <NavLink to="/notes" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [05] Notes & Logs
                    </NavLink>
                    <NavLink to="/videos" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [06] Video Logs
                    </NavLink>
                    <NavLink to="/certs" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [07] Certificates
                    </NavLink>
                    {/* Added Networking Link */}
                    <NavLink to="/networking" onClick={closeMobileMenu} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        [08] Networking
                    </NavLink>
                </nav>

                {/* NEW SIDEBAR WIDGETS (Weather, Clock, etc.) */}
                <SidebarWidgets />

                {/* Authentication & User Status Section */}
                <div className="auth-sidebar-section" style={{ marginTop: 'auto', borderTop: '1px solid #ccc', paddingTop: '20px' }}>
                    {loading ? (
                        <div style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>Loading user...</div>
                    ) : currentUser ? (
                        <div>
                            <div style={{ fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '5px' }}>
                                👤 {currentUser.name}
                            </div>
                            <div style={{ fontSize: '0.75rem', color: '#666', marginBottom: '10px' }}>
                                {currentUser.email}
                            </div>

                            {isRealAdmin && (
                                <div style={{
                                    fontSize: '0.7rem',
                                    background: '#000',
                                    color: '#fff',
                                    display: 'inline-block',
                                    padding: '2px 5px',
                                    marginBottom: '10px'
                                }}>
                                    ADMIN_ACCESS_GRANTED
                                </div>
                            )}

                            <button
                                onClick={logout}
                                style={{
                                    display: 'block',
                                    background: 'transparent',
                                    border: '1px solid #333',
                                    padding: '5px 10px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem',
                                    width: '100%'
                                }}
                            >
                                [LOGOUT]
                            </button>
                        </div>
                    ) : (
                        <div>
                            <div style={{ fontSize: '0.8rem', marginBottom: '10px', fontStyle: 'italic' }}>
                                Guest Access
                            </div>
                            <button
                                onClick={login}
                                style={{
                                    background: '#db4437', // Google Red
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    fontSize: '0.85rem',
                                    width: '100%',
                                    fontWeight: 'bold'
                                }}
                            >
                                [Login with Google]
                            </button>
                        </div>
                    )}
                </div>

            </aside>
            <main className="academic-content">
                {children}
            </main>
        </div>
    );
};

export default AcademicLayout;
